<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="门店列表"
    :width="'360px'"
    :before-close="cancelHandle"
    :destory-on-close="true"
    :append-to-body="true"
    @open="handleOpen"
  >
    <div class="store_list_wrap" v-loading="loading">
      <div class="store_list_item" v-for="item in storeList" :key="item.id">
        <div class="store_list_item_name">{{ item.storeName }}</div>
        <div class="company">
          <el-button
            @click="modifyStoreUseState(item)"
            type="primary"
            size="mini"
            v-if="
              item.auditState === 1 &&
              (item.useState === 0 || item.useState === 2)
            "
            >确认使用</el-button
          >
          <el-button
            @click="modifyStoreUseState(item)"
            size="mini"
            v-if="item.auditState === 1 && item.useState === 1"
            >取消使用</el-button
          >
          <div v-if="item.auditState !== 1">
            {{ Number(item.auditState) === 0 ? '审核中' : '审核拒绝' }}
          </div>
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class="store_list_tips">
        <span>{{ storeListDialogText.text }}</span>
        <span class="mark">{{ storeListDialogText.mark }}</span>
      </div>
      <div class="mt16" style="text-align: center">
        <el-button size="small" @click="cancelHandle">取消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="handleOK"
          :loading="submitLoading"
          :disabled="changeIds.length === 0"
          >确认</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import config from '../config'
import { storeListByCollaborationId, storeUsageChange } from '../services'
import { mapGetters } from 'vuex'

export default {
  name: 'storeListDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const { storeListDialogText } = config.call(this)
    return {
      storeListDialogText,
      storeList: [],
      changeIds: [],
      loading: false,
      submitLoading: false,
    }
  },
  methods: {
    // dialog初始化
    handleOpen() {
      this.submitLoading = false
      // 获取门店列表
      this.getStoreListByCollaborationId()
    },
    cancelHandle() {
      this.storeList = []
      this.changeIds = []
      this.$emit('close')
    },
    handleOK() {
      this.setStoreUsageChange(this.changeIds)
    },
    modifyStoreUseState(item) {
      const index = this.changeIds.findIndex((child) => child.id === item.id)
      if (index > -1) {
        this.changeIds[index].useState =
          item.useState === 0 || item.useState === 2 ? 1 : 0
      } else {
        this.changeIds.push({
          id: item.id,
          useState: item.useState === 0 || item.useState === 2 ? 1 : 0,
        })
      }

      this.storeList = this.storeList.map((child) => {
        if (child.id === item.id) {
          if (item.useState === 0 || item.useState === 2) {
            child.useState = 1
          } else {
            child.useState = 0
          }
        }
        return child
      })
    },
    async getStoreListByCollaborationId() {
      this.loading = true
      storeListByCollaborationId({ id: this.id }).then(({ code, data }) => {
        if (code === 1 && data) {
          this.storeList = data || []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    async setStoreUsageChange(changeIds) {
      if (this.submitLoading) return
      this.submitLoading = true
      try {
        const { code } = await storeUsageChange({ changeIds })

        if (code !== 1) {
          this.submitLoading = false
          return
        }
        this.$message.success('更新成功')
        this.$emit('close')
      } catch {
        this.submitLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.store_list_wrap{
  width: 100%;
  min-height: 168px;
  overflow-y: auto;
}
.store_list_item {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;

  .store_list_item_name {
    width: 60%;
    height: 32px;
    line-height: 32px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.store_list_tips {
  color: #99a9bf;
  font-size: 12px;
  font-style: normal;
  text-align: left;
  .mark {
    color: rgb(250, 83, 83);
  }
}

.company {
  display: flex;
  align-items: center;
}
</style>
